import WasteCollectionAreaCreate from "../components/views/wasteCollectionArea/wasteCollectionAreaCreate.vue";
import WasteCollectionArea from "../components/views/wasteCollectionArea/wasteCollectionArea.vue";
import wasteCollectionAreaDetails from "../components/views/wasteCollectionArea/wasteCollectionAreaDetails.vue";
import collectionDivisionCreate from "../components/views/wasteCollectionArea/collectionDivisionCreate.vue";
import lineTowerList from "../components/views/wasteCollectionArea/lineTowerList.vue";
import houseList from "../components/views/wasteCollectionArea/houseList.vue";
const routes = [
  {
    path: "wasteCollectionArea",
    component: WasteCollectionArea,
    name: "wasteCollectionArea",
    meta: {
      description: "",
      title: "Zone",
      requiresAuth: true,
    },
  },
  {
    path: "wasteCollectionArea/wasteCollectionAreaCreate/:_id",
    component: WasteCollectionAreaCreate,
    name: "wasteCollectionAreaCreate",
    meta: {
      // description: 'Add/Update a new Ward Details',
      title: "Add / Update Zone",
      requiresAuth: true,
    },
  },
  {
    path: "wasteCollectionArea/wasteCollectionAreaDetails/:_id",
    component: wasteCollectionAreaDetails,
    name: "wasteCollectionAreaDetails",
    meta: {
      // description: "Ward Details",
      title: "Ward",
      requiresAuth: true,
    },
  },
  {
    path: "wasteCollectionArea/collectionDivisionCreate",
    component: collectionDivisionCreate,
    name: "collectionDivisionCreate",
    meta: {
      // description: 'Add/Update a new Collection Division',
      title: "Add / Update Collection Division",
      requiresAuth: true,
    },
  },
  {
    path: "wasteCollectionArea/wasteCollectionAreaDetails/:cdId/:_id",
    component: lineTowerList,
    name: "lineTowerList",
    meta: {
      description: "List of Line / Tower",
      title: "Line / Tower",
      requiresAuth: true,
    },
  },


  // {
  //   path: "wasteCollectionArea/line-tower-list/:_id ",
  //   component: lineTowerList,
  //   name: "lineTowerList",
  //   meta: {
  //     description: "List of Line / Tower",
  //     title: "Line / Tower",
  //     requiresAuth: true,
  //   },
  // },

  {
    path: "wasteCollectionArea/wasteCollectionAreaDetails/:cdId/:_id",
    component: houseList,
    name: "houseList",
    meta: {
      description: "",
      title: "Houses",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/wasteCollectionArea.route.js